import { useContext } from "react";
import { MobileMenuContext } from "./MobileMenuContext";

export const useMobileMenu = () => useContext(MobileMenuContext);
